export default __webpack_public_path__ + "static/media/website_summerizer.175e6a71.PNG";